export const editorButtonTokens = {
  primary: '#9738ff',
  primaryForeground: '#ffffff',
  primaryActive: '#6c11d1',
  primaryDeep: '#43008f',
  primaryDisabled: '#a9a9a9',
  secondary: '#f8f1ff',
  secondaryActive: '#e7d6f7',
  secondaryDisabled: '#e7d6f7',
  buttonGroupBackground: '#f8f1ff',
  buttonGroupActive: '#e7d6f7',
  buttonGroupSeparator: '#e7d6f7',
  neutralGrey1: '#f1f1f1',
  neutralGrey3: '#a9a9a9',
  neutralGrey4: '#6f6f6f',
  neutralGrey5: '#2e2e2e',
  radius: '8px',
  height: '38px',
  fontFamily: "'Plus Jakarta Sans', ui-sans-serif, system-ui, sans-serif"
} as const;
